const ARABIC = 'ARABIC'
const CHINESE = 'CHINESE'
const CHINESE_TRADITIONAL = 'CHINESE_TRADITIONAL'
const CZECH = 'CZECH'
const DANISH = 'DANISH'
const DUTCH = 'DUTCH'
export const ENGLISH = 'ENGLISH'
const FINNISH = 'FINNISH'
const FRENCH = 'FRENCH'
const GERMAN = 'GERMAN'
const HEBREW = 'HEBREW'
const INDONESIAN = 'INDONESIAN'
const ITALIAN = 'ITALIAN'
const JAPANESE = 'JAPANESE'
const KOREAN = 'KOREAN'
const POLISH = 'POLISH'
const PORTUGUESE = 'PORTUGUESE'
const RUSSIAN = 'RUSSIAN'
const SPANISH = 'SPANISH'
const SWEDISH = 'SWEDISH'
const TURKISH = 'TURKISH'

export const LANGUAGES = [
    ARABIC,
    CHINESE,
    CHINESE_TRADITIONAL,
    CZECH,
    DANISH,
    DUTCH,
    ENGLISH,
    FINNISH,
    FRENCH,
    GERMAN,
    HEBREW,
    INDONESIAN,
    ITALIAN,
    JAPANESE,
    KOREAN,
    POLISH,
    PORTUGUESE,
    RUSSIAN,
    SPANISH,
    SWEDISH,
    TURKISH,
]

export const AR = 'ar'
export const ZH = 'zh'
export const ZH_TW = 'zh-TW'
export const CS = 'cs'
export const DA = 'da'
export const NL = 'nl'
export const EN = 'en'
export const FI = 'fi'
export const FR = 'fr'
export const DE = 'de'
export const HE = 'he'
export const ID = 'id'
export const IT = 'it'
export const JA = 'ja'
export const KO = 'ko'
export const PL = 'pl'
export const PT = 'pt'
export const RU = 'ru'
export const ES = 'es'
export const SV = 'sv'
export const TR = 'tr'

const CODES = [
    AR,
    ZH,
    ZH_TW,
    CS,
    DA,
    NL,
    EN,
    FI,
    FR,
    DE,
    HE,
    ID,
    IT,
    JA,
    KO,
    PL,
    PT,
    RU,
    ES,
    SV,
    TR,
]

export const LANGUAGE_CODE_MAP = (() => {
    let bimap = {}
    LANGUAGES.map((language, index) => {
        bimap[language] = CODES[index]
        bimap[CODES[index]] = language
        return null
    })
    return bimap
})()
